import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormControl, InputLabel, Select, MenuItem, styled } from '@mui/material';
import { ORDERED_BICS, bicToName } from '../utils/bicMappings';

const SelectorContainer = styled('div')(({ theme }) => ({
  width: '200px',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

interface Props {
  bic: Bic;
  onChange: (bic: Bic) => void;
}

export const PartnerBankSelector = ({ bic, onChange }: Props) => {
  const { t } = useTranslation();

  const handleOnChange = (event: any) => {
    onChange(event.target.value);
  };

  return (
    <SelectorContainer>
      <FormControl fullWidth>
        <InputLabel id="partner-bank-selector-label" sx={{ marginTop: '16px' }}>
          {t('cashbackCalculator.detailed.partnerBankSelector.label')}
        </InputLabel>
        <Select
          labelId="partner-bank-selector-label"
          id="partner-bank-selector"
          variant="filled"
          value={bic}
          onChange={handleOnChange}
          inputProps={{ 'data-hj-whitelist': true }}
        >
          {ORDERED_BICS.map((bic, index) => {
            return (
              <MenuItem value={bic} key={index}>
                {bicToName(bic)}
              </MenuItem>
            );
          })}
          <MenuItem value="OTHER_BANK" key="otherBank">
            {t('cashbackCalculator.detailed.partnerBankSelector.otherBank')}
          </MenuItem>
        </Select>
      </FormControl>
    </SelectorContainer>
  );
};
